/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_QcInputs */



/**
* | output |
* | --- |
* | "Automatic QC & Style Guides" |
*
* @param {Signup_Compare_QcInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_qc = /** @type {((inputs?: Signup_Compare_QcInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_QcInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Automatic QC & Style Guides")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatic QC & Style Guides")
	if (locale === "it") return /** @type {LocalizedString} */ ("Automatic QC & Style Guides")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Automatic QC & Style Guides")
	if (locale === "es") return /** @type {LocalizedString} */ ("Automatic QC & Style Guides")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Automatic QC & Style Guides")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Automatic QC & Style Guides")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Automatic QC & Style Guides")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Automatic QC & Style Guides")
	return /** @type {LocalizedString} */ ("Automatic QC & Style Guides")
});